import { Menu } from "@mui/material";
import { palette, shape, typography } from "@src/core/styles";
import styled from "styled-components";
import type { LogComponentProps } from "./log-component.types";

export const LogContainer = styled.div<LogComponentProps>`
  display: ${({ formType, formMethod }) =>
    formType === "routes" && formMethod === "update" ? "block" : "none"};
  padding: 48px 12px 0 12px;
  overflow: auto;
  width: 336px;
  border-left: ${palette.border.grey};
`;

export const LogHeader = styled.div`
  ${typography.headline_large};
  display: flex;
  justify-content: space-between;
  align-items: center;

  & button.MuiButton-root:hover {
    background-color: inherit;
  }
`;

export const LogCount = styled.div`
  ${typography.label_small_medium};
  color: ${palette.colors.onsurface_variant};
  padding-top: 8px;
  border-top: ${palette.border.outline};
  margin-top: 12px;
`;

export const LogsList = styled.ul`
  margin: 16px 0;
  transition: all ease-in 0.1s;
`;

export const ListItem = styled.ul`
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LogName = styled.span`
  ${typography.body_large_regular};
  color: ${palette.colors.link};
  &:hover {
    color: ${palette.colors.green_base};
  }
`;

export const LogDate = styled.span`
  ${typography.label_small_medium};
  color: ${palette.colors.onsurface_variant};
`;

export const DatePickerWrapper = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const StyledMenu = styled(Menu)`
  && {
    & .MuiPaper-root {
      border-radius: ${shape.rounding.XXL};
      width: 480px;
    }
    & .MuiMenu-list {
      padding: 0;
      box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.15),
        0px 1px 2px 0px rgba(0, 0, 0, 0.3);
      background-color: ${palette.colors.surface_container};
    }
  }
`;

export const MenuLabel = styled.div`
  ${typography.label_large};
  color: ${palette.colors.onsurface_variant};
  margin-bottom: 36px;
  padding: 12px 24px 0 24px;
`;

export const MenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${typography.headline_large};
  border-bottom: ${palette.border.grey};
  padding: 0 24px 8px 24px;
`;

export const DatePickerGroup = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 18px 24px 16px 24px;
`;

export const MenuFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  color: ${palette.colors.green_base};
  padding: 8px 12px 12px 12px;
`;

export const MenuFooterButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  ${typography.label_large};
  color: ${palette.colors.green_base};
`;

export const ButtonWrapper = styled.div`
  display: none;
`;

export const CenterBlock = styled.div`
  display: flex;
  justify-content: center;
`;
